<div class="maintenance-wrapper">
  <div class="container">
    <div class="row">
      <img src="assets/images/warning-icon.svg" alt="Warning Icon" class="warning-icon">
      <h4 translate>WE_ARE_UPGRADING</h4>
      <p translate>MAINTENANCE_MESSAGE</p>
    </div>
  </div>
</div>